export default __webpack_public_path__ + "static/backgroundHome--blurV-697bc0df7bc3fc675192e9a4c46b8ea4.webp";